import React from 'react';
import { MIN_COLS, MAX_COLS, COLS_TO_SKIP, INIT_COL_CLASS, CTA_TYPE_NAME } from '../consts';
import { cn } from 'utils/styles';
import styles from '../RichTextTable.module.css';
import { Node } from '@contentful/rich-text-types';
import { TableChild } from '../types';

export const renderTableRow = (_node: Node, children: React.ReactNode) => {
  const tableChildren = React.Children.toArray(children) as TableChild[];
  const cells = tableChildren.filter(c => c.type === 'td' || c.type === 'th');
  const cellCount = cells.length;

  // Check if the row contains a LinkButton
  const hasCta = cells.some(cell =>
    cell.props.children.some(c => c.props.children.some(n => n?.props?.__typename === CTA_TYPE_NAME)),
  );

  const lessThanMax = cellCount < MAX_COLS;
  const isMin = cellCount == MIN_COLS;
  const className = cn(
    `${lessThanMax ? styles.firstCol50 : styles.firstCol33}`,
    `${isMin ? styles.lastColHidden : ''}`,
    `${hasCta ? `rowHasCta ${styles.rowHasCta}` : ''}`,
  );

  return (
    <tr className={className}>
      {/*
      Set a data-column property on each cell within the row
      Add classes to be used in switchColumn() :
        colHidden - if compare column should be hidden on mobile
        init      - if compare column should be initially displayed on mobile
      */}
      {tableChildren.map((child, i) => {
        if (child.type === 'td' || child.type === 'th') {
          const dataColumn = i;

          // Check if the cell contains a LinkButton
          const hasCta = child.props.children.some(c =>
            c.props.children.some(n => n?.props?.__typename === CTA_TYPE_NAME),
          );

          const className = cn(
            `${i > COLS_TO_SKIP ? styles.colHidden : i === 2 ? INIT_COL_CLASS : ''}`,
            `${hasCta ? styles.cellHasCta : ''}`,
            styles.cell, // Add a cell class for element agnostic styling
          );

          return React.cloneElement(child, { 'data-column': dataColumn, className });
        }
        return child;
      })}
      {/* If row has minimum cells, add an empty td for layout */}
      {isMin && <td aria-hidden className={styles.cell}></td>}
    </tr>
  );
};
